import { render, staticRenderFns } from "./UnderReview.vue?vue&type=template&id=6ead1408&"
import script from "./UnderReview.vue?vue&type=script&lang=js&"
export * from "./UnderReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports